import type { LogEntry } from '@/types/log-entry';

// Waypoint is the generic location entity in this codebase (renamed from Location in M45b)
export interface RecapWaypoint {
  id: string;
  name: string;
}

/**
 * Returns the name of the waypoint with the most scouting log entries.
 * - Groups entries by waypointId
 * - Picks the waypointId with the highest count
 * - Resolves name from the provided waypoints array
 * - Returns null when entries is empty
 */
export function computeTopStandByObservations(
  entries: LogEntry[],
  waypoints: RecapWaypoint[],
): string | null {
  if (entries.length === 0) return null;

  // Count entries per waypointId
  const countMap = new Map<string, number>();
  for (const entry of entries) {
    countMap.set(entry.waypointId, (countMap.get(entry.waypointId) ?? 0) + 1);
  }

  // Find waypointId with the highest count; stable tie-break: first encountered in iteration
  let topId = '';
  let topCount = 0;
  for (const [waypointId, count] of countMap) {
    if (count > topCount) {
      topId = waypointId;
      topCount = count;
    }
  }

  if (!topId) return null;

  // Resolve name — fallback to "Unnamed" if waypoint not found
  const waypoint = waypoints.find((w) => w.id === topId);
  return waypoint?.name ?? 'Unnamed';
}
